import Head from 'next/head';

import { useFeatures } from '@atc/features';

export default function PixallPreload() {

    const {
        pixall: [enablePixall, { src: pixallSrc }],
    } = useFeatures([
        'pixall',
    ]);

    return enablePixall && typeof window !== 'undefined' && !window.Pixall && (
        <Head>
            <link
                key="pixallScript"
                rel="preload"
                href={pixallSrc}
                as="script"
            />
        </Head>
    );
}
